import React from "react";
import { Box, Typography, Button } from "@mui/material";
import { Error as ErrorIcon } from "@mui/icons-material";

/**
 * A component to display an error state with an optional retry action
 *
 * @param {Object} props
 * @param {string} props.message - Error message to display
 * @param {Function} props.onRetry - Optional retry callback function
 * @param {Object} props.sx - Additional styles to apply
 */
const ErrorState = ({ message = "An error occurred", onRetry, sx = {} }) => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        py: 4,
        ...sx,
      }}
    >
      <ErrorIcon color="error" sx={{ fontSize: 48, mb: 2 }} />

      <Typography variant="h6" color="error" align="center" gutterBottom>
        {message}
      </Typography>

      {onRetry && (
        <Button
          variant="contained"
          color="primary"
          onClick={onRetry}
          sx={{ mt: 2 }}
        >
          Try Again
        </Button>
      )}
    </Box>
  );
};

export default ErrorState;
